// Services
import apiClient from '@/services/AccountClient'

export default {
  create (profileId, data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/wallets/${profileId}`,
      data
    )
  },
  update (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      data
    )
  },
  block (id, reason) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/wallets/${id}/block`,
      { reason }
    )
  },
  unblock (id) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/wallets/${id}/block`
    )
  },
  addAccountNumber (id, { accountNumber, channel, currencies }) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/wallets/${id}/accountNumbers`,
      { accountNumber, channel, currencies }
    )
  },
  restoreAccountNumber (id, { accountNumber }) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/wallets/${id}/accountNumbers/${accountNumber}/restore`
    )
  },
  updateAccountNumberCurrencies (id, accountNumber, currencies) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}/accountNumbers/${accountNumber}/currencies`,
      { currencies }
    )
  },
  deleteAccountNumber (id, { accountNumber, reason, channel }) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/wallets/${id}/accountNumbers`,
      { accountNumber, reason, channel }
    )
  },
  useForFee (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      { useForFee: true }
    )
  },
  useAsMaster (id, feeAccountId) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      { useAsMaster: true, feeWalletId: feeAccountId }
    )
  },
  useForVault (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      { useForVault: true }
    )
  },
  setRecurringFeeFree (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      { recurringFeeFree: true }
    )
  },
  unsetRecurringFeeFree (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/wallets/${id}`,
      { recurringFeeFree: false }
    )
  },
  debtWriteOff (id) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/wallets/${id}/debt-write-off`
    )
  },
  resolveIban (iban) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/accounts/resolve`,
      { q: iban }
    )
  },
  resolveSwift (swift) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/accounts/swift/resolve`,
      { bic: swift }
    )
  },
  fetchRequisites (accountId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/accounts/requisites/${accountId}`
    )
  },
  sendRequisites (accountId, details) {
    const query = apiClient.serializeParams(details)

    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/accounts/requisites/${accountId}/export?${query}`
    )
  },
  updateBankDetails (paymentId, bankDetails) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/payments/${paymentId}/accountant/external-beneficiary`,
      bankDetails
    )
  }
}
